import React from 'react'
import { graphql, StaticQuery } from 'gatsby';

import DataProvider from 'providers/data';

import * as style from 'styles/global/navigation.module.scss';
import Link from 'components/Link';

const Navigation = props => (
	<StaticQuery
		query={graphql`
		{
			allContentMenu(filter: {menuID: {eq: "main"}}) {
				edges {
					node {
						pages
					}
				}
			}
		}
		`}
		render={(data) => {
			let classes = [style.container, style.dropdownMenu, style.main];

			const { edges: menuEdges } = data.allContentMenu;
			let mainMenu = menuEdges.map(({ node }) => node.pages)[0];
			if ((props.providerResponse.data.length > 0 || !!mainMenu !== false) && props.providerStatusText === "LOADED") {
				mainMenu = props.providerResponse.data.filter(datum => datum.menuID === "main")[0].pages;
			}

			return (
				<nav datalayer="Primary Nav" className={classes.join(' ')}>
					{mainMenu.length && mainMenu.map((i, index) => {
						let submenuLinks = []

						if (i.hasOwnProperty("children")) submenuLinks = i.children
						if (!JSON.parse(i.visible)) return null;
						return (
							<li key={`main-nav-${index}`} className={`${style.linkWrapper}`}>
								<Link className={style.link} to={i.href}>{i.text.replaceAll(" ", "\n")}</Link>
								{submenuLinks.length > 0 &&
									<div className={`${style.menu} ${style.col}`}>
										{submenuLinks.map(({ text, href, visible }, index) => !JSON.parse(visible) ? null : <div className={[style.dropdownItem, "cell"].join(' ')} key={index}><Link to={href}>{text}</Link></div>)}
									</div>
								}
							</li>
						)
					})}
				</nav>
			)
		}}
	/>
)

const getData = props => (
	<DataProvider liveRefresh={true} type="ContentMenu">
		<Navigation {...props} />
	</DataProvider>
)

export default getData;